import { tv } from "@opensea/ui-kit"
import { fullBleedVariants } from "@/styles/utils/page-container"

const heroHeaderMediaVariants = tv({
  base: "",
  variants: {
    headerView: {
      full: "",
      compact: "top-sm-top-nav lg:top-lg-top-nav lg:h-hero-header-compact",
    },
    isCollectionBanner: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    {
      headerView: "full",
      isCollectionBanner: false,
      class:
        "aspect-12/11 md:aspect-16/9 lg:aspect-8/3 xl:aspect-4/1 xl:max-h-[466px] xl:min-w-full",
    },
    {
      headerView: "full",
      isCollectionBanner: true,
      class:
        "aspect-16/9 md:aspect-16/9 lg:aspect-8/3 xl:h-[min(670px,_100vh_-_270px)] xl:min-w-full",
    },
  ],
})

export const heroHeaderScrollOffsetVariants = tv({
  base: "-mt-sm-top-nav lg:-mt-lg-top-nav pointer-events-none opacity-0",
  variants: {
    headerView: {
      full: fullBleedVariants(),
      compact:
        "h-[calc(theme(spacing.sm-top-nav)+theme(spacing.hero-header-compact))] lg:h-[calc(theme(spacing.lg-top-nav)+theme(spacing.hero-header-compact))]",
    },
    isCollectionBanner: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    {
      headerView: "full",
      isCollectionBanner: false,
      class: heroHeaderMediaVariants({
        headerView: "full",
        isCollectionBanner: false,
      }),
    },
    {
      headerView: "full",
      isCollectionBanner: true,
      class: heroHeaderMediaVariants({
        headerView: "full",
        isCollectionBanner: true,
      }),
    },
  ],
})

export const fixedHeroHeaderViewVariants = tv({
  extend: heroHeaderMediaVariants,
  base: "pointer-events-auto absolute right-0 flex w-full",
})

export const headerViewCompactVariants = tv({
  slots: {
    container: "flex w-full items-end",
    content:
      "flex w-full min-w-0 flex-col lg:flex-row lg:justify-between lg:gap-4",
  },
})
